import React from 'react';
import {
  Grid, Header, Label, List,
} from 'semantic-ui-react';
import History from './History';
import MixpanelTracker from '../../../utils/MixpanelTracker';

const Content = ({ expert }) => {
  const uniqueTags = Array.from(new Set([...expert.medical_specialties, ...expert.functions,
    ...expert.technology_tags, expert.organization.type].filter((x) => x)));

  React.useEffect(() => {
    const hyperlinkNodes = document.getElementsByTagName('a');
    const elements = Object.values(hyperlinkNodes).filter((e) => e.innerText === 'LinkedIn');
    elements.forEach((e) => e.addEventListener('click', () => {
      MixpanelTracker.trackClickLinkedInLink(expert);
    }));
  }, []);

  return (
    <Grid container stackable>
      <Grid.Column width={10} className="detail">
        <Grid container>
          <Grid.Row>
            <Grid.Column>
              <Header>{`About ${expert.fullName}`}</Header>
              <div className="section">
                {expert.description ? expert.description : expert.infoFromLinkedin}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Header>Expert Tags</Header>
              {uniqueTags.length > 0 && (
                <List className="tags-section">
                  {uniqueTags.map((t) => <Label key={t} size="small">{t}</Label>)}
                </List>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
      <Grid.Column width={6} className="history">
        <Grid container>
          <Grid.Row>
            <Grid.Column>
              <Header>Projects with my team</Header>
              <History expertId={expert.id} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    </Grid>
  );
};

export default Content;
